import { Redirect, Route, RouteProps } from 'react-router-dom';

import { getAppRoutes } from './App.constants';
import PrivateApp, { PrivateAppPropsBase } from './PrivateApp';
import Permission, { PermissionProps } from 'Components/Permission/Permission';
import TenantProvider from 'Pages/TenantProvider';
import { useStores } from 'Hooks/useStore';

type PrivateRouteProps = RouteProps &
	PrivateAppPropsBase & {
		// eslint-disable-next-line
		component: any;
		showHeader?: boolean,
		permission?: Omit<PermissionProps, 'children'>;
		bypassPermissionForSuperAdmin?: boolean;
		skipTenantProvider?: boolean;
	};

function PrivateRoute({
	component: Component,
	permission,
	showHeader = false,
	includeLayout,
	bypassPermissionForSuperAdmin = false,
	skipTenantProvider = false,
	...routeProps
}: PrivateRouteProps) {
	const { authStore } = useStores();

	const route = (
		<Route
			{...routeProps}
			render={(props) => {
				const children = <Component {...props} />;
				return permission ? (
					<Permission {...(permission as PermissionProps)}>
						{({ permitted }) => {
							const isBypassed =
								bypassPermissionForSuperAdmin &&
								authStore.isCurrentUserSuperAdmin;
							return permitted || isBypassed ? (
								children
							) : (
								<Redirect
									to={getAppRoutes().ERROR_PERMISSION}
								/>
							);
						}}
					</Permission>
				) : (
					children
				);
			}}
		/>
	);

	return (
		<PrivateApp includeLayout={includeLayout}>
			{skipTenantProvider ? (
				route
			) : (
				<TenantProvider showHeader={showHeader}>{route}</TenantProvider>
			)}
		</PrivateApp>
	);
}

export default PrivateRoute;